module.exports = "simple-language"